export enum CreateCaseEditorTabs {
  Rechtsfragen = 'rechtsfragen',
  Anspruchsgrundlagen = 'anspruchsgrundlagen',
  Voraussetzungen = 'voraussetzungen',
  Ergebnis = 'ergebnis',
  Grade = 'grade'
}

export interface Chunk {
  index: string;
  heading: string;
  paragraph: string;
}

export interface FocusPoint {
  id: number;
  tabName: string;
  title: string;
  chunkIds: string[];
  fp_text?: string;
  max_points?: number;
}
